import React from 'react';

import Base from './Base.jsx';

import TradingViewChart from '../Components/TradingViewChart/index.jsx';


class EntryPoint extends Base {
  id() {
    return 'cs-tradingview-chart';
  }

  renderElement(element) {
    var id = element.dataset.id;

    return (
      <TradingViewChart symbol={id} />
    );
  }
}


export default EntryPoint;

